import { ShellNav } from './ShellNav';

export function BottomNav() {
  return <ShellNav variant="bottom" />;
}
